import React, { useState, useEffect } from 'react';
import { getData, putData } from '../helpers/ApiSettings';

const DEFAULT_FREE_DELIVERY_THRESHOLD = 59;

const GeneralSettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [isFirstTimeSetup, setIsFirstTimeSetup] = useState(false);
  const [formData, setFormData] = useState({
    free_delivery_threshold: DEFAULT_FREE_DELIVERY_THRESHOLD,
  });

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const response = await getData('/general-setting');
      if (response.data?.data) {
        setFormData({
          free_delivery_threshold: response.data.data.free_delivery_threshold ?? DEFAULT_FREE_DELIVERY_THRESHOLD,
        });
        setIsFirstTimeSetup(false);
      } else {
        setIsFirstTimeSetup(true);
      }
      setError(null);
    } catch (err) {
      if (err?.response?.status === 404) {
        // Premier accès : on garde la valeur par défaut (déjà dans le state).
        setIsFirstTimeSetup(true);
      } else {
        console.error('Error fetching general settings:', err);
        setError('Erreur lors du chargement des paramètres');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      await putData('/general-setting', {
        data: {
          free_delivery_threshold: parseFloat(formData.free_delivery_threshold),
        },
      });
      alert('Paramètres mis à jour avec succès');
    } catch (err) {
      alert('Erreur lors de la mise à jour');
      console.error('Error saving general settings:', err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="h4 mb-0">Paramètres généraux</h2>
      </div>

      {error && (
        <div className="alert alert-danger">{error}</div>
      )}

      {isFirstTimeSetup && (
        <div className="alert alert-warning">
          <strong>Première utilisation :</strong> les valeurs ci-dessous correspondent aux valeurs par défaut actuellement utilisées sur le site. Vous pouvez les modifier puis enregistrer.
        </div>
      )}

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <h5 className="mb-3">Livraison</h5>

              <div className="mb-3">
                <label htmlFor="free_delivery_threshold" className="form-label">
                  Seuil de livraison gratuite (€)
                </label>
                <div className="input-group" style={{ maxWidth: '300px' }}>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    className="form-control"
                    id="free_delivery_threshold"
                    value={formData.free_delivery_threshold}
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      free_delivery_threshold: e.target.value,
                    }))}
                    required
                  />
                  <span className="input-group-text">€</span>
                </div>
                <small className="text-muted">
                  Au-delà de ce montant d'achat, la livraison est offerte sur la boutique en ligne (côté Vente).
                </small>
              </div>
            </div>

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
